var _circle, _g, _path, _path2, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUserFilledinline = function SvgUserFilledinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6356_33738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6356_33738)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F2ECDE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6356_33738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.078 13.034A5.999 5.999 0 0 1 16 8c2.794 0 5.147 1.912 5.77 4.5h-1.645a2.992 2.992 0 0 1-2.536-1.399c-.834 1.29-2.217 2.149-3.839 2.149h-2.625c-.37 0-.727-.08-1.047-.216ZM18.939 23a7.56 7.56 0 0 1 7.561 7.56c0 .793-.647 1.44-1.44 1.44H6.94c-.795 0-1.44-.647-1.44-1.44A7.56 7.56 0 0 1 13.06 23h5.88Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.59 11.101a2.99 2.99 0 0 0 2.535 1.4h1.645c.164.477.23.941.23 1.5a6 6 0 1 1-11.923-.967c.321.141.678.216 1.048.216h2.625c1.622 0 3.005-.86 3.84-2.149Z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6356_33738)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#C8AF6C"
  }))));
};

export default SvgUserFilledinline;